import { useState } from 'react';

const faqs = [
  {
    question: 'Who can join FutureLeadX programs?',
    answer:
      'Any students, graduates, and post-graduates can join the programs.',
  },
  {
    question: 'Are the courses online or offline?',
    answer: 'The courses are online.',
  },
  {
    question: 'Do you provide internships?',
    answer:
      'Yes. We offer multiple internship opportunities, and top performers may earn an exclusive internship opportunity with BPS Group.',
  },
  {
    question: 'How can colleges collaborate with FutureLeadX?',
    answer:
      'Colleges can partner with FutureLeadX by visiting our website and submitting the College Partnership Form. Our team will review the request and connect with the institution to discuss collaboration opportunities.',
  },
  {
    question: 'Do you guarantee placements?',
    answer:
      "No. We do not guarantee placements. However, we provide comprehensive placement assistance, including resume building, mock interviews, career guidance, and access to multiple job opportunities. Final selection depends on the student's skills, performance, and the employer's hiring criteria.",
  },
  {
    question: 'Is there any certification?',
    answer: 'Yes, we provide certification courses.',
  },
];

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className="overflow-hidden rounded-xl border border-brand-border bg-brand-white shadow-[0_8px_24px_-18px_rgba(17,22,44,0.35)]">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left sm:gap-4 sm:px-5 sm:py-4"
        aria-expanded={isOpen}
      >
        <span className="text-[14px] font-semibold leading-snug text-brand-navy sm:text-body">
          {question}
        </span>
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-background text-brand-navy transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
          aria-hidden="true"
        >
          <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </button>

      <div
        className={`grid transition-all duration-300 ease-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <p className="border-t border-brand-border/70 px-5 py-4 text-body-sm leading-relaxed text-brand-secondary">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="bg-brand-white py-6 lg:py-10">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="mx-auto mb-10 max-w-2xl text-center lg:mb-14">
          <p className="mb-3 text-label font-semibold uppercase tracking-[0.2em] text-brand-primary">
            Need Help?
          </p>
          <h2 className="text-section uppercase tracking-wide text-brand-navy sm:text-[36px]">
            Frequently Asked Questions
          </h2>
          <div className="mx-auto mt-5 h-1 w-16 rounded-full bg-brand-primary" />
        </div>

        <div className="grid items-start gap-4 md:grid-cols-2 md:gap-5">
          {faqs.map((faq, index) => (
            <FaqItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() =>
                setOpenIndex((prev) => (prev === index ? null : index))
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
